<template>
  <div class="layer" v-if="show" @click.self="close">
    <div class="box">
      <img
        class="close"
        src="../assets/image/general_icon_closeads@2x.png"
        @click="close"
      />
      <div class="box__tit">会员权益</div>
      <div class="list">
        <div class="list__inner">
          <div class="item" v-for="item in list" :key="item.id">
            <img class="item__img" :src="item.icon" />
            <div class="item__text">
              <div class="item__tit">{{ item.title }}</div>
              <div class="item__subTit">{{ item.subtitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    list: {
      type: Array
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.box {
  width: 87.2%;
  max-height: 4.56rem;
  background: #ffffff;
  border-radius: 16px;
  position: fixed;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
}
.close {
  position: absolute;
  width: 40px;
  height: 40px;
  top: -56px;
  right: 0;
}
.box__tit {
  font-size: 24px;
  font-weight: bold;
  color: rgba(107, 70, 6, 1);
  height: 81px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list {
  max-height: 3.75rem;
  overflow-y: scroll;
}
.item {
  display: flex;
  padding: 0 16px;
  align-items: center;
  margin-bottom: 12px;
}
.item__img {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  margin-right: 12px;
}
.item__text {
  width: calc(100% - 82px);
  flex-direction: column;
  display: flex;
  justify-content: center;
  /* align-items: center; */
}
.item__tit {
  font-size: 0.16rem;
}
.item__subTit {
  color: #666666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.layer {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6);
}
</style>
